import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts)
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const BubbleChart: any =(props:any)=>{

    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton} = props;
    const options = {

        chart: {
            type: 'bubble',
            backgroundColor: '#f0f0f0',
            
            plotBorderWidth: 1,
            zoomType: 'xy'
        },
    
        title: {
            text: title
        },
        subtitle: {
            text: ''
        },
        
        responsive: {  
			rules: [{  
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
                legend: {
                    align: 'right',
                    verticalAlign: 'bottom',
                    layout: 'horizontal'
                },
               
                subtitle: {
                    text: null
                },
                credits: {
                    enabled: false
                }
            }
			}]  
		},

        xAxis: {
            startOnTick: false,
            endOnTick: false,
            title:{
                text:'CONOCIMIENTO'
            },
            plotLines: [{
                color: 'black',
                dashStyle: 'dot',
                width: 2,
                value: 50,
                label: {
                    rotation: 0,
                    y: 15,
                    style: {
                        fontStyle: 'italic'
                    },
                },
                zIndex: 3
            }]
        },
    
        yAxis: {
            startOnTick: false,
            endOnTick: false,
            title:{
                text:'Imagen Positiva'
            },
            plotLines: [{
                color: 'black',
                dashStyle: 'dot',
                width: 2,
                value: 50,
                visible: true,
                label: {
                    align: 'right',
                    style: {
                        fontStyle: 'italic'
                    },
                    text: '',
                    x: -10
                },
                zIndex: 3
            }],
            
        },
        //
        series: allData,

        tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr style="color: {series.color}"><th colspan="2">{series.name}</th></tr>',
			pointFormat: '<tr><td><b>Conocimiento:</b> </td>' +
				        '<td style="text-align: right"><b>{point.x}%</b></td></tr>' +
                        '<tr><td><b>Imagen Positiva:</b> </td>' +
				        '<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},

        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    format: '{point.name}'
                }
            }
        },
        lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		},
        exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}

        
    
    };
    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default BubbleChart;